import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.js";

export function RequireSignedIn({ children }: { children: ReactNode }) {
  const { isReady, signedOut } = useAuth();
  if (!isReady) return null;
  if (signedOut) return <Navigate to="/login" replace />;
  return children;
}
